export const VENDORID_CELLPHONE_RECHARGE = (parseInt(process.env.REACT_APP_VENDOR_RECHARGE) || 71)

export const SERVICETYPE_MOBILE_RECHARGE = 1

export const REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE = 5

export const REGULATION_TYPE_CAMPAIGN = 'Campaign'
export const REGULATION_TYPE_CAMPAIGN_AND_VENDOR = 'VendorAndRegulationType'
export const REGULATION_TYPE_VENDOR = 'Vendor'

export default {
  VENDORID_CELLPHONE_RECHARGE,
  SERVICETYPE_MOBILE_RECHARGE,
  REGULATION_TYPE_SCHEDULE_MOBILE_RECHARGE
}



// WEBPACK FOOTER //
// ./src/Participant/Scheduling/constants.js